import * as actionTypes from "../ActionTypes";
import { put, call, takeLatest, takeEvery } from "redux-saga/effects";
import * as api from "./BibleAPI";
import { actionUpdateGlobalLoaderSagaAction } from "../GlobalLoader/GlobalLoaderAction";

function* getBibleLanguagesSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getBibleLanguages, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getBibleVersionsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getBibleVersions, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getVersionBooksSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getVersionBooks, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getChapterDetailsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getChapterDetails, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getBibleSearchSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getBibleSearch, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getChapterVideosSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getChapterVideos, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* saveChapterVideosSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.saveChapterVideos, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deleteChapterVideosSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteChapterVideos, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getChapterJournalsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getChapterJournals, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* saveChapterJournalsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.saveChapterJournals, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deleteChapterJournalsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteChapterJournals, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getVerseDetailsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getVerseDetails, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getBibleCountryLanguagesSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getBibleCountryLanguages, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getSpeakersListSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getSpeaker, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* saveSpeakerDetailsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.saveSpeakerDetails, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* updateSpeakerDetailsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updateSpeakerDetails, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deleteSpeakerSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteSpeaker, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getJournalCategoriesSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getJournalCategories, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* saveJournalCategoriesSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.saveJournalCategoriesDetails, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* updateJournalCategoriesSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updateJournalCategoriesDetails, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deleteJournalCategoriesSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteJournalCategories, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* getPlansSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getPlans, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* savePlansSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getPlans, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* updatePlansSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updatePlans, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deletePlansSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deletePlans, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* savePlanThumbnailSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.savePlanThumbnail, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* updatePlanThumbnailSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updatePlanThumbnail, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* savePlanDaySaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.savePlanDay, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* updatePlanDaySaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updatePlanDay, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deletePlanDaySaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deletePlanDay, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* saveRelatedPlansSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.saveRelatedPlans, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deleteRelatedPlansSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteRelatedPlans, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* updatePlanCategorySaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updatePlanCategory, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deletePlanCategorySaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deletePlanCategory, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* saveCategoryPlanSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.saveCategoryPlan, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

function* deleteCategoryPlanSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteCategoryPlan, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

// Journal Speaker Language Saga
export function* saveJournalLanguageSpeakerSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.saveJournalLanguageSpeaker, payload);
        action.payload.callback(response);
  } catch (err) {
      } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

// Journal Category Language Saga
export function* updateJournalLanguageSpeakerSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updateJournalLanguageSpeaker, payload);
        action.payload.callback(response);
  } catch (err) {
      } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

export function* deleteJournalLanguageSpeakerSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteJournalLanguageSpeaker, payload);
        action.payload.callback(response);
  } catch (err) {
      } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

// Journal Category Language Saga
export function* saveJournalLanguageCategorySaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.saveJournalLanguageCategory, payload);
        action.payload.callback(response);
  } catch (err) {
      } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

export function* updateJournalLanguageCategorySaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updateJournalLanguageCategory, payload);
        action.payload.callback(response);
  } catch (err) {
      } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

export function* deleteJournalLanguageCategorySaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteJournalLanguageCategory, payload);
        action.payload.callback(response);
  } catch (err) {
      } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

// Journal Language Saga
export function* saveJournalLanguageSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.saveJournalLanguage, payload);
        action.payload.callback(response);
  } catch (err) {
      } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

export function* updateJournalLanguageSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updateJournalLanguage, payload);
        action.payload.callback(response);
  } catch (err) {
      } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

export function* deleteJournalLanguageSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteJournalLanguage, payload);
        action.payload.callback(response);
  } catch (err) {
      } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

// Journal Notes Langugage Saga
export function* saveJournalLanguageNotesSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.saveJournalLanguageNotes, payload);
        action.payload.callback(response);
  } catch (err) {
      } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

export function* updateJournalLanguageNotesSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updateJournalLanguageNotes, payload);
        action.payload.callback(response);
  } catch (err) {
      } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

export function* deleteJournalLanguageNotesSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteJournalLanguageNotes, payload);
        action.payload.callback(response);
  } catch (err) {
      } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

// Jorunal NoteItems Language Saga
export function* saveJournalLanguageNoteItemsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.saveJournalLanguageNoteItems, payload);
        action.payload.callback(response);
  } catch (err) {
      } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

export function* updateJournalLanguageNoteItemsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.updateJournalLanguageNoteItems, payload);
        action.payload.callback(response);
  } catch (err) {
      } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

export function* deleteJournalLanguageNoteItemsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.deleteJournalLanguageNoteItems, payload);
        action.payload.callback(response);
  } catch (err) {
      } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}
function* getJournalsSaga(action) {
  yield put(actionUpdateGlobalLoaderSagaAction(true));
  try {
    const payload = action.payload.apiPayloadRequest;
    const response = yield call(api.getJournals, payload);
        action.payload.callback(response);
  } catch (err) {
    if (err?.response) {
          } else {
          }
  } finally {
    yield put(actionUpdateGlobalLoaderSagaAction(false));
  }
}

export default function* BibleWatcherSaga() {
  //Bible Listeners
  yield takeLatest(actionTypes.GET_JOURNALS, getJournalsSaga);

  yield takeLatest(actionTypes.GET_BIBLE_LANGUAGES_REQUEST, getBibleLanguagesSaga);
  yield takeLatest(actionTypes.GET_BIBLE_VERSIONS_REQUEST, getBibleVersionsSaga);
  yield takeLatest(actionTypes.GET_VERSION_BOOKS_REQUEST, getVersionBooksSaga);
  yield takeLatest(actionTypes.GET_BIBLE_CHAPTER_DETAILS, getChapterDetailsSaga);
  yield takeLatest(actionTypes.GET_BIBLE_SEARCH, getBibleSearchSaga);

  yield takeLatest(actionTypes.READ_CHAPTER_VIDEOS_REQUEST, getChapterVideosSaga);
  yield takeLatest(actionTypes.SAVE_CHAPTER_VIDEOS_REQUEST, saveChapterVideosSaga);
  yield takeLatest(actionTypes.DELETE_CHAPTER_VIDEOS_REQUEST, deleteChapterVideosSaga);
  yield takeLatest(actionTypes.READ_CHAPTER_JOURNALS_REQUEST, getChapterJournalsSaga);
  yield takeLatest(actionTypes.SAVE_CHAPTER_JOURNALS_REQUEST, saveChapterJournalsSaga);
  yield takeLatest(actionTypes.DELETE_CHAPTER_JOURNALS_REQUEST, deleteChapterJournalsSaga);
  yield takeLatest(actionTypes.READ_VERSE_DETAILS_REQUEST, getVerseDetailsSaga);
  yield takeLatest(actionTypes.GET_BIBLE_COUNTRY_LANGUAGES_REQUEST, getBibleCountryLanguagesSaga);

  yield takeLatest(actionTypes.GET_SPEAKERS_LIST_REQUEST, getSpeakersListSaga);
  yield takeLatest(actionTypes.SAVE_SPEAKER_DETAILS_REQUEST, saveSpeakerDetailsSaga);
  yield takeLatest(actionTypes.UPDATE_SPEAKER_DETAILS_REQUEST, updateSpeakerDetailsSaga);
  yield takeLatest(actionTypes.DELETE_SPEAKER_DETAILS_REQUEST, deleteSpeakerSaga);

  yield takeLatest(actionTypes.GET_JOURNAL_CATEGORIES_REQUEST, getJournalCategoriesSaga);
  yield takeLatest(actionTypes.SAVE_JOURNAL_CATEGORIES_REQUEST, saveJournalCategoriesSaga);
  yield takeLatest(actionTypes.UPDATE_JOURNAL_CATEGORIES_REQUEST, updateJournalCategoriesSaga);
  yield takeLatest(actionTypes.DELETE_JOURNAL_CATEGORIES_REQUEST, deleteJournalCategoriesSaga);

  //Plan Listeners
  yield takeLatest(actionTypes.GET_PLANS_REQUEST, getPlansSaga);
  yield takeLatest(actionTypes.SAVE_PLANS_REQUEST, savePlansSaga);
  yield takeLatest(actionTypes.UPDATE_PLANS_REQUEST, updatePlansSaga);
  yield takeLatest(actionTypes.DELETE_PLANS_REQUEST, deletePlansSaga);
  yield takeLatest(actionTypes.SAVE_PLAN_THUMBNAIL_REQUEST, savePlanThumbnailSaga);
  yield takeLatest(actionTypes.UPDATE_PLAN_THUMBNAIL_REQUEST, updatePlanThumbnailSaga);
  yield takeLatest(actionTypes.SAVE_PLAN_DAY_REQUEST, savePlanDaySaga);
  yield takeLatest(actionTypes.UPDATE_PLAN_DAY_REQUEST, updatePlanDaySaga);
  yield takeLatest(actionTypes.DELETE_PLAN_DAY_REQUEST, deletePlanDaySaga);
  yield takeLatest(actionTypes.SAVE_RELATED_PLANS_REQUEST, saveRelatedPlansSaga);
  yield takeLatest(actionTypes.DELETE_RELATED_PLANS_REQUEST, deleteRelatedPlansSaga);
  yield takeLatest(actionTypes.UPDATE_PLAN_CATEGORY_REQUEST, updatePlanCategorySaga);
  yield takeLatest(actionTypes.DELETE_PLAN_CATEGORY_REQUEST, deletePlanCategorySaga);
  yield takeLatest(actionTypes.SAVE_CATEGORY_PLAN_REQUEST, saveCategoryPlanSaga);
  yield takeLatest(actionTypes.DELETE_CATEGORY_PLAN_REQUEST, deleteCategoryPlanSaga);

  // Journal Speaker
  yield takeEvery(
    actionTypes.SAVE_JOURNAL_LANGUAGE_SPEAKER_REQUEST,
    saveJournalLanguageSpeakerSaga
  );
  yield takeEvery(
    actionTypes.UPDATE_JOURNAL_LANGUAGE_SPEAKER_REQUEST,
    updateJournalLanguageSpeakerSaga
  );
  yield takeEvery(
    actionTypes.DELETE_JOURNAL_LANGUAGE_SPEAKER_REQUEST,
    deleteJournalLanguageSpeakerSaga
  );

  // Journal Category
  yield takeEvery(
    actionTypes.SAVE_JOURNAL_LANGUAGE_CATEGORY_REQUEST,
    saveJournalLanguageCategorySaga
  );
  yield takeEvery(
    actionTypes.UPDATE_JOURNAL_LANGUAGE_CATEGORY_REQUEST,
    updateJournalLanguageCategorySaga
  );
  yield takeEvery(
    actionTypes.DELETE_JOURNAL_LANGUAGE_CATEGORY_REQUEST,
    deleteJournalLanguageCategorySaga
  );

  // Journal Language
  yield takeEvery(actionTypes.SAVE_JOURNAL_LANGUAGE_REQUEST, saveJournalLanguageSaga);
  yield takeEvery(actionTypes.UPDATE_JOURNAL_LANGUAGE_REQUEST, updateJournalLanguageSaga);
  yield takeEvery(actionTypes.DELETE_JOURNAL_LANGUAGE_REQUEST, deleteJournalLanguageSaga);

  // Journal Language Notes
  yield takeEvery(actionTypes.SAVE_JOURNAL_LANGUAGE_NOTES_REQUEST, saveJournalLanguageNotesSaga);
  yield takeEvery(
    actionTypes.UPDATE_JOURNAL_LANGUAGE_NOTES_REQUEST,
    updateJournalLanguageNotesSaga
  );
  yield takeEvery(
    actionTypes.DELETE_JOURNAL_LANGUAGE_NOTES_REQUEST,
    deleteJournalLanguageNotesSaga
  );

  // Journal Language NoteItems
  yield takeEvery(
    actionTypes.SAVE_JOURNAL_LANGUAGE_NOTEITEMS_REQUEST,
    saveJournalLanguageNoteItemsSaga
  );
  yield takeEvery(
    actionTypes.UPDATE_JOURNAL_LANGUAGE_NOTEITEMS_REQUEST,
    updateJournalLanguageNoteItemsSaga
  );
  yield takeEvery(
    actionTypes.DELETE_JOURNAL_LANGUAGE_NOTEITEMS_REQUEST,
    deleteJournalLanguageNoteItemsSaga
  );
}
